// Third-party
import React from 'react';
import classNames from 'classnames';
import InvisibleButton from '../../buttons/InvisibleButton';
import { formatMessage } from '@/utils/i18n';

type Props = {
  checked?: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
};

const CollapseToggle = ({ checked = false, onChange, className, ...rest }: Props) => {
  const ariaLabel = checked ? formatMessage('CollapseToggle.Collapse') : formatMessage('CollapseToggle.Expand');

  return (
    <InvisibleButton onClick={() => onChange(!checked)} ariaLabel={ariaLabel} className={classNames(className, 'collapse-toggle', { expanded: checked })}>
      <i className="icon-plus-med" aria-hidden="true" data-testid="test-togglePlus" />
      <i className="icon-minus-med" aria-hidden="true" data-testid="test-toggleMinus" />
    </InvisibleButton>
  );
};

export default CollapseToggle;
